<template>
  <section>
    <v-flex xs12 md12 pt-2 pl-2 pr-2>
      <v-card>
        <v-card-title primary-title class="headline primary">
          <v-layout row align-center>
            <v-btn
              dark
              icon
              @click="$router.push('/settings/pricing/ride_types/')"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <span class="title font-weight-light white--text"
              >Add Ride Type</span
            >
          </v-layout>
        </v-card-title>
        <v-card-text key="1">
          <RideTypeForm
            ref="rideTypeForm"
            :rideType="rideType"
            :tariff="tariff"
            :errors="errors"
            @validityChange="updateFormValidity($event)"
            @imageInput="handleImageInput"
          />
          <v-layout align-center justify-left>
            <h4 class="grey--text text--darken-1">Current Modifiers -&nbsp;</h4>
            <h5 class="nobold grey--text text--darken-1">
              Drag and drop to re-order
            </h5>
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              class="text-none pa-1"
              flat
              @click="addTariffModifier()"
              >Add Tariff Modifier</v-btn
            >
          </v-layout>
          <v-flex pt-2>
            <TariffModifierList
              :modifiers="tariff.modifiers"
              @edit="editTariffModifier($event)"
              @orderChange="changeModifierOrder($event)"
            />
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="text-none" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
      <TariffModifierForm
        v-if="showModifierDialog"
        ref="tariffModifierForm"
        :show="showModifierDialog"
        :modifierData="tariffModifierData"
        :errors="errors.tariff ? errors.tariff.modifiers[modifierIndex] : {}"
        @cancel="cancelTariffModifier()"
        @save="saveTariffModifier($event)"
        @snackbar="showSnackbar($event.message, $event.colour)"
      />
      <v-snackbar
        v-model="snackbarShow"
        :color="snackbarColour"
        :timeout="4000"
        >{{ snackbarMessage }}</v-snackbar
      >
    </v-flex>
  </section>
</template>

<script>
import RideTypeForm from "@/components/settings/pricing/RideTypeForm.vue";
import TariffModifierForm from "@/components/settings/pricing/TariffModifierForm.vue";
import TariffModifierList from "@/components/settings/pricing/TariffModifierList.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "create_ride_type",
  components: {
    RideTypeForm,
    TariffModifierForm,
    TariffModifierList,
  },
  props: {},
  data: function () {
    return {
      rideType: {
        name: "",
        description: "",
        image: {},
        num_seats: "",
        disabled_access: false,
        premium_vehicle: false,
        enabled: true,
        requires_prebooking: false,
        wait_time_period: 0,
      },
      tariff: {
        base_fare: "",
        per_mile_fare: "",
        per_minute_fare: "",
        additional_charge: "",
        modifiers: [],
      },
      errors: {},
      rideTypeFormValid: false,
      showModifierDialog: false,
      tariffModifierData: {},
      editModifierIndex: -1,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
    };
  },
  methods: {
    submit: async function () {
      if (!this.showModifierDialog) {
        if (this.rideTypeFormValid) {
          let self = this;
          let url = `${this.$store.state.apiUrl}/settings/ride_types/create`;

          var rideType = JSON.parse(JSON.stringify(this.rideType));

          rideType.name = encodeURIComponent(this.rideType.name);
          rideType.alternative_name = encodeURIComponent(
            rideType.alternative_name
          );
          rideType.description = encodeURIComponent(this.rideType.description);

          axios({
            url: url,
            method: "post",
            data: JSON.stringify({
              ride_type: this.rideType,
              tariff: this.convertTariffPoundsToPence(),
            }),
            headers: {
              "Content-Type": "text/plain",
            },
          })
            .then(function (response) {
              console.log(response.data.errors);
              if (response.data.errors) {
                self.errors = response.data.errors;
                if (self.errors.ride_type && self.errors.tariff) {
                  self.errors = {
                    ...self.errors.ride_type,
                    ...self.errors.tariff,
                  };
                }
                self.showSnackbar(
                  "Error adding ride type, please check the form",
                  "error"
                );
              } else if (response.data.error != "no_error") {
                self.showSnackbar(
                  "Error adding ride type: " + response.data.error,
                  "error"
                );
                console.log(response.data.error);
              } else {
                self.$router.push("../ride_types");
              }
            })
            .catch(function (error) {
              console.log(error);
              self.showSnackbar("Network error: " + error, "error");
            });
        } else {
          this.showSnackbar(
            "Please complete the form before submitting",
            "error"
          );
          this.$refs.rideTypeForm.validateForm();
        }
      } else {
        this.showSnackbar(
          "Please finish adding/editing the modifier before submitting",
          "error"
        );
      }
    },
    updateFormValidity: function (value) {
      this.rideTypeFormValid = value;
    },
    handleImageInput: function (file) {
      this.rideType.image = file;
    },
    showSnackbar: function (message, colour) {
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
    addTariffModifier: function () {
      this.tariffModifierData = {
        name: "",
        //Default to last priority
        priority: this.tariff.modifiers.length + 1,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        bank_holiday: false,
        hour_period_start: "",
        hour_period_end: "",
        day_period_start_date: "",
        day_period_start_month: "",
        day_period_start_time: "",
        day_period_end_date: "",
        day_period_end_month: "",
        day_period_end_time: "",
        base_fare: "",
        per_mile_fare: "",
        per_minute_fare: "",
        additional_charge: "",
      };

      this.modifierIndex = -1;
      this.showModifierDialog = true;
    },
    cancelTariffModifier: function () {
      this.showModifierDialog = false;
      this.modifierIndex = -1;
    },
    saveTariffModifier: function (modifier) {
      if (this.modifierIndex == -1) {
        this.tariff.modifiers.push(modifier);
      } else {
        //https://vuejs.org/2016/02/06/common-gotchas/
        //this.tariff.modifiers[this.modifierIndex] = modifier;
        this.tariff.modifiers.splice(this.modifierIndex, 1, modifier);
      }
      this.showModifierDialog = false;
      this.modifierIndex = -1;
    },
    editTariffModifier: function (index) {
      this.tariffModifierData = Object.assign({}, this.tariff.modifiers[index]);
      this.modifierIndex = index;
      this.showModifierDialog = true;
    },
    changeModifierOrder: function (newModifiers) {
      for (let i = 0; i < newModifiers.length; i++) {
        newModifiers[i].priority = i + 1;
      }
      this.tariff.modifiers = newModifiers;
      this.tariff.modifiers.sort(function (a, b) {
        return a.priority - b.priority;
      });
    },
    convertTariffPoundsToPence: function () {
      //Copy not use reference
      let newTariff = JSON.parse(JSON.stringify(this.tariff));

      newTariff.base_fare = Math.round(newTariff.base_fare * 100);
      newTariff.per_mile_fare = Math.round(newTariff.per_mile_fare * 100);
      newTariff.per_minute_fare = Math.round(newTariff.per_minute_fare * 100);
      newTariff.additional_charge = newTariff.additional_charge * 100;

      newTariff.modifiers.forEach(function (modifier) {
        modifier.base_fare = Math.round(modifier.base_fare * 100);
        modifier.per_mile_fare = Math.round(modifier.per_mile_fare * 100);
        modifier.per_minute_fare = Math.round(modifier.per_minute_fare * 100);
        modifier.additional_charge = Math.round(
          modifier.additional_charge * 100
        );
      });

      return newTariff;
    },
  },
};
</script>